module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/y0HKP8/images/cover.jpg?1684229395980",
      "alt": "This image is the cover for the book Curious Life of Nevada's LaVere Redfield: The Silver Dollar King"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Curious Life of Nevada's LaVere Redfield: The Silver Dollar King\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("LaVere Redfield was a prolific hoarder. When he died in 1974, his estate was estimated at more than $70 million. Executors found 680 bags of silver coins and 407,000 Morgan and Peace silver dollars in his Reno mansion. A local Reno legend, Redfield gambled regularly in Virginia Street casinos. He survived robbery and burglaries of his home, which contained false walls to store millions of silver dollars. Hating banks and paper money, as well as big government, Redfield opted to serve a prison term for income tax evasion rather than pay his debts from his ample fortune. Join author Jack Harpster for this first book-length study of this unconventional man behind the folklore and the myth.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack Harpster\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jack Harpster grew up in Memphis, Tennessee, and graduated from the University of Wisconsin School of Journalism. The Reno, Nevada resident was the executive director of advertising for the Las Vegas Review-Journal and worked at the Las Vegas Sun. His books include \"John Ogden, the Pilgrim (1609, 1682): A Man of More Than Ordinary Mark, \" a biography of his great-grandfather, an early colonial settler; and \"King of the Slots: William 'Si' Redd.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0